import * as api from '../api'
import useApiMutation from './useApiMutation'
import useInvalidate from '../useInvalidate'

export default function useRemoveLearningAssignmentsFromGroups() {
  const invalidate = useInvalidate()

  return useApiMutation({
    mutationFn: async ({ groupUuids, learningItemUuids }: { groupUuids: string[]; learningItemUuids: string[] }) => {
      await api.del('course/unassign/learning-items-from-groups', {
        groups: groupUuids,
        learning_items: learningItemUuids,
      })

      await Promise.all([invalidate.users(), invalidate.groups()])
    },
  })
}
